//
// VENDOR CONFIG
//

// Vendor name is used for generating URL prefix. e.g. https://payment-options.futurefamily.com/vendor-name/
export const VENDOR_NAME = 'fairfax';
// Passed along to App Flow for co-branding and selection of vendor
export const VENDOR_ID = '4802255177121792';
// Redirect URL when clicking on Schedule Appointment CTA
export const RETURN_URL = 'https://www.fairfaxeggbank.com/contact-us/';

export const BASENAME = process.env.REACT_APP_BASENAME || '/' + VENDOR_NAME;
export const UTM_PARAMETERS = `utm_source=${VENDOR_NAME}&utm_campaign=embedded-finance&utm_medium=calculator`;
export const APP_FLOW_URL = 'https://app.futurefamily.com/apply/sign-up';

export const LOAN_MINIMUM = 5000;
export const LOAN_MAXIMUM = 50000;
export const DOWNPAYMENT_MINIMUM = 1000;
export const APR = 5.99;
export const DEFAULT_TERM = 60;
export const FULLSTORY_ORG_ID = process.env.REACT_APP_FULLSTORY_ORG_ID || '10FCNS';
